import { createReducer, PayloadAction } from '@reduxjs/toolkit';

import {
    postLoginRequest,
    postLoginSuccess,
    postLoginFailure,
    postForgotPasswordRequest,
    postForgotPasswordSuccess,
    postForgotPasswordFailure,
    validateResetPasswordCodeRequest,
    validateResetPasswordCodeSuccess,
    validateResetPasswordCodeFailure,
    postResetPasswordRequest,
    postResetPasswordSuccess,
    postResetPasswordFailure,
} from '@actions/auth';

interface AuthState {
    isPosting: boolean;
    postSuccess: boolean;
    error: string | null;
}

const initialState: AuthState = {
    isPosting: false,
    postSuccess: false,
    error: null,
};

export default createReducer(initialState, {
    [postLoginRequest.type]: handlePostRequest,
    [postLoginSuccess.type]: handlePostSuccess,
    [postLoginFailure.type]: handleFailure,
    [postForgotPasswordRequest.type]: handlePostRequest,
    [postForgotPasswordSuccess.type]: handlePostSuccess,
    [postForgotPasswordFailure.type]: handleFailure,
    [validateResetPasswordCodeRequest.type]: handlePostRequest,
    [validateResetPasswordCodeSuccess.type]: handlePostSuccess,
    [validateResetPasswordCodeFailure.type]: handleFailure,
    [postResetPasswordRequest.type]: handlePostRequest,
    [postResetPasswordSuccess.type]: handlePostSuccess,
    [postResetPasswordFailure.type]: handleFailure,
});

function handlePostRequest(state: AuthState) {
    state.isPosting = true;
    state.postSuccess = false;
    state.error = null;
}

function handlePostSuccess(state: AuthState) {
    state.isPosting = false;
    state.postSuccess = true;
}

function handleFailure(state: AuthState, action: PayloadAction<string>) {
    state.isPosting = false;
    state.error = action.payload;
}
